export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Sessies.vue?vue&type=template&id=f6bbd03e&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Sessies.vue?vue&type=template&id=f6bbd03e&
// module id = 345
// module chunks = 0